import React, { useContext } from 'react';
import cn from 'classnames';
import { MFBeaconButton } from '../Beacon/BeaconComponents';
import styles from './styles.css';
import { FlowContext } from '../../core/flow-engine';
import { generateGeneralTestID } from '../../generateAutomationTestIDs';

/*eslint-disable */
const Card = ({
  buttonFunction,
  buttonText,
  cardID,
  icon,
  learnMore,
  learnMoreType,
  spacedTitle,
  buttonDisabled = false,
  buttonID = '',
  note = '',
  displayNote = '',
  title = '',
  subtitle = ''
}) => {
  const { next } = useContext(FlowContext);

  const handleButtonClick = event => {
    event.stopPropagation();
    buttonFunction();
  };

  return (
    <div
      {...(!learnMore &&
        !buttonDisabled && { onClick: () => buttonFunction() })}
      role="button"
      className={cn('card', {
        'show-pointer': !learnMore && !buttonDisabled
      })}
      data-name={cardID}>
      {icon && <img className="card-img" alt={title} src={icon} />}

      <div className={cn('card-title', { 'spaced-title': spacedTitle })}>
        {title}
      </div>

      <div className="card-subtitle">{subtitle}</div>

      {learnMore && (
        <span className="learn-more-btn">
          <MFBeaconButton
            id="learnMoreCardBtn"
            data-name={generateGeneralTestID('Card', 'LearnMoreButton')}
            type="button"
            className="beacon-button-margin-override"
            onClick={next('LEARN_MORE', learnMoreType)}
            variant="tertiary"
            label="Learn more"></MFBeaconButton>
        </span>
      )}

      <span className="card-button">
        <MFBeaconButton
          id={buttonID}
          data-name={generateGeneralTestID('Card', 'ContinueButton')}
          type="button"
          className="beacon-button-margin-override"
          disabled={buttonDisabled}
          onClick={handleButtonClick}
          variant="primary"
          label={buttonText}></MFBeaconButton>
      </span>

      {displayNote && <div className="note">{note}</div>}
      <style jsx>{styles}</style>
    </div>
  );
  /* eslint-enable */
};

export default Card;
